/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostTagListRequest {
    getFixupPrototypeFunction() { return CostTagListRequest.fixupPrototype; }

    static newInstance(model: Partial<CostTagListRequest>): CostTagListRequest {
        let obj = Object.assign(new CostTagListRequest(), model);
        CostTagListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostTagListRequest>): CostTagListRequest {
        if (!model) return null;
        return CostTagListRequest.newInstance(<CostTagListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostTagListRequest) {
        if (!obj) return;

        models.CostTagListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostTagListRequest): boolean {
        Object.setPrototypeOf(obj, CostTagListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AccountFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.CostTagSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.CostTagSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AccountFilters;

}
